// Mock data for the physiotherapy clinic website

export const clinicData = {
  // Team members with professional credentials
  teamMembers: [
    {
      id: 1,
      name: "Dr. Chadavadada Deevena Angel",
      credentials: "M.P.T., B.P.T., M.I.A.P",
      // specialty: "Geriatric Care & Wellness",
      // experience: "8 years",
      image: "/angel1.webp",
      // description:
      //   "Dedicated to improving quality of life for senior patients through specialized care programs.",
    },
    //  {
    //   id: 2,
    //   name: "Dr. Balaga Damodara Rao",
    //   credentials: "B.P.T.",
      // specialty: "Pain Management & Chronic Care",
      // experience: "15 years",
      // image: "/DamodaraRao.jpg",
      // description:
      //   "Expert in comprehensive pain management and long-term chronic condition treatment.",
    // },
    {
      id: 3,
      name: "Dr. Karri Kavya",
      credentials: "B.P.T.",
      // specialty: "Geriatric Care & Wellness",
      // experience: "8 years",
      image: "/Karri Kavya.webp",
      // description:
      //   "Dedicated to improving quality of life for senior patients through specialized care programs.",
    },
    // {
    //   id: 4,
    //   name: "Dr. Telegareddy Divya Deepika",
    //   credentials: "B.P.T.",
    //   specialty: "Sports Injury & Rehabilitation",
    //   experience: "4 years",
    //   image: "/Divya Deepika.webp",
    //   description:
    //     "Specializes in sports injury recovery and performance optimization for athletes.",
    // },
   {
      id: 5,
      name: "Dr. Sirapanasetti Naveen",
      credentials: "B.P.T., M.B.A.",
      // specialty: "Geriatric Care & Wellness",
      // experience: "8 years",
      image: "/Naveen.jpg",
      // description:
      //   "Dedicated to improving quality of life for senior patients through specialized care programs.",
    },
    {
      id: 4,
      name: "Dr. Karu Theresa",
      credentials: "B.P.T.",
      // specialty: "Physiotherapy",
      // experience: "1 year ",
      image: "/Teresa.webp",
      // description:
      //   "Specializes in sports injury recovery and performance optimization for athletes.",
    },
    // {
    //   id: 6,
    //   name: "Dr. Sala Hari Priya",
    //   credentials: "B.P.T.",
    //   specialty: "Orthopedic Rehabilitation",
    //   experience: "10 years",
    //   image: "/Hari Priya.jpg",
    //   description:
    //     "Focuses on post-surgical recovery and musculoskeletal rehabilitation programs.",
    // },
  ],

  // Services offered
  services: [
    {
      id: 1,
      title: "Sports Injury Recovery",
      description:
        "Comprehensive rehabilitation programs designed for athletes and active individuals to return to peak performance.",
      icon: "trophy",
      features: [
        "Performance Analysis",
        "Injury Prevention",
        "Recovery Optimization",
        "Return-to-Sport Protocol",
      ],
    },
    {
      id: 2,
      title: "Pain Relief & Management",
      description:
        "Advanced pain management techniques using cutting-edge technology and personalized treatment plans.",
      icon: "heart",
      features: [
        "Chronic Pain Treatment",
        "Acute Pain Relief",
        "Non-invasive Therapies",
        "Lifestyle Modification",
      ],
    },
    {
      id: 3,
      title: "Chiropractic Care",
      description:
        "Expert spinal manipulation and adjustment techniques for optimal spinal health and nervous system function.",
      icon: "spine",
      features: [
        "Spinal Alignment",
        "Posture Correction",
        "Headache Relief",
        "Joint Mobility",
      ],
    },
    {
      id: 4,
      title: "Rehabilitation",
      description:
        "Comprehensive post-injury and post-surgical rehabilitation programs tailored to individual needs.",
      icon: "refresh",
      features: [
        "Post-Surgery Recovery",
        "Mobility Restoration",
        "Strength Building",
        "Functional Training",
      ],
    },
    {
      id: 5,
      title: "Customized Wellness Programs",
      description:
        "Personalized wellness and prevention programs to maintain optimal health and prevent future injuries.",
      icon: "star",
      features: [
        "Health Assessments",
        "Preventive Care",
        "Fitness Planning",
        "Lifestyle Coaching",
      ],
    },
    {
      id: 6,
      title: "Corporate Wellness",
      description:
        "Workplace health programs designed to improve employee wellbeing and reduce workplace injuries.",
      icon: "building",
      features: [
        "Ergonomic Assessments",
        "Group Sessions",
        "Health Screenings",
        "Injury Prevention",
      ],
    },
  ],

  // Branch locations
  branches: [
    {
      id: 1,
      name: "Gajuwaka Branch",
      address: "Chinagantyada Junction, Kanithi Road, Gajuwaka",
      hours: {
        weekdays: "09:00 AM to 09:00 PM",
        // saturday: "8:00 AM - 4:00 PM",
        sunday: "09:00 AM to 05:00 PM",
      },
      phone: "+91 92810 10745",
      // specialties: [
      services: [
        "Outpatient Services",
        // "Sports Medicine",
        // "Pain Management",
        // "Rehabilitation",
      ],
      image: "downtown-clinic.jpg",
    },
    {
      id: 2,
      name: "Kurmannapalem Branch",
      address: "Duvvada Rd, Kurmannapalem, Visakhapatnam",
      hours: {
        weekdays: "09:00 AM to 09:00 PM",
        // saturday: "8:00 AM - 3:00 PM",
        sunday: "09:00 AM to 05:00 PM",
      },
      phone: "+91 84999 61352",
      services: [
        "Inpatient Services",
        "Outpatient Services"
        // "Wellness Programs",
        // "Geriatric Care",
        // "Corporate Health",
      ],
      image: "lakeside-clinic.jpg",
    },
  ],

  // Client testimonials
  testimonials: [
     {
      id: 1,
      name: "Robert Harrison",
      role: "Corporate Executive",
      image:
        "https://images.unsplash.com/photo-1703759354716-b777fd195508?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxzYXRpc2ZpZWQlMjBjbGllbnRzfGVufDB8fHx8MTc1MzAzNzIyNnww&ixlib=rb-4.1.0&q=85",
      testimonial:
        "Our corporate wellness sessions have boosted team morale and significantly reduced workplace injuries. Outstanding professional service.",
      rating: 5,
    },
    {
      id: 2,
      name: "Jennifer Mitchell",
      role: "Professional Athlete",
      image:
        "https://images.unsplash.com/photo-1575433287483-8ec588f72417?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxzYXRpc2ZpZWQlMjBjbGllbnRzfGVufDB8fHx8MTc1MzAzNzIyNnww&ixlib=rb-4.1.0&q=85",
      testimonial:
        "The care I received helped me recover fully from a severe knee injury. I'm back to competing at my highest level thanks to the expert team.",
      rating: 5,
    },
    {
      id: 3,
      name: "Marcus Johnson",
      role: "Fitness Enthusiast",
      image:
        "https://images.unsplash.com/photo-1684607631635-44399dee5ac9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxoYXBweSUyMHBhdGllbnRzfGVufDB8fHx8MTc1MzAzNzIxMHww&ixlib=rb-4.1.0&q=85",
      testimonial:
        "After years of persistent lower back pain, the personalized treatment program completely changed my life. I'm pain-free and stronger than ever.",
      rating: 5,
    },
    {
      id: 4,
      name: "Lisa Chen",
      role: "Senior Manager",
      image:
        "https://images.unsplash.com/photo-1542596594-649edbc13630?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxoYXBweSUyMHBlb3BsZXxlbnwwfHx8fDE3NTMwMzcyMzJ8MA&ixlib=rb-4.1.0&q=85",
      testimonial:
        "The rehabilitation program exceeded all my expectations. The staff's expertise and dedication made my recovery journey smooth and successful.",
      rating: 5,
    },
    {
      id: 5,
      name: "Community Wellness Group",
      role: "Group Program Participants",
      image:
        "https://images.unsplash.com/photo-1687436874044-2c593fbf0245?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzcyUyMHJlY292ZXJ5fGVufDB8fHx8MTc1MzAzNzIxOHww&ixlib=rb-4.1.0&q=85",
      testimonial:
        "The group wellness programs have transformed our community's approach to health. Everyone feels more empowered and healthier.",
      rating: 5,
    },
    {
      id: 6,
      name: "Women's Wellness Circle",
      role: "Health & Wellness Group",
      image:
        "https://images.unsplash.com/photo-1687181133399-668ddc50065c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHx3ZWxsbmVzcyUyMHJlY292ZXJ5fGVufDB8fHx8MTc1MzAzNzIxOHww&ixlib=rb-4.1.0&q=85",
      testimonial:
        "The specialized women's wellness programs address our unique health needs with compassion and expertise. Life-changing experience.",
      rating: 5,
    },
    {
      id: 7,
      name: "Active Seniors Group",
      role: "Senior Wellness Participants",
      image:
        "https://images.unsplash.com/photo-1686749143613-0eeacff36894?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHx3ZWxsbmVzcyUyMHJlY292ZXJ5fGVufDB8fHx8MTc1MzAzNzIxOHww&ixlib=rb-4.1.0&q=85",
      testimonial:
        "The senior-focused programs have improved our mobility, strength, and overall quality of life. We feel younger and more confident.",
      rating: 5,
    },
  ],

  // Corporate wellness packages
  corporatePackages: [
    {
      id: 1,
      size: "Small Business",
      employees: "10-50 employees",
      features: [
        "Monthly Health Screenings",
        "Ergonomic Assessments",
        "Injury Prevention Workshops",
        "Basic Wellness Education",
        "Email Support",
      ],
      price: "Custom Pricing",
      popular: false,
    },
    {
      id: 2,
      size: "Medium Enterprise",
      employees: "51-200 employees",
      features: [
        "Bi-weekly Health Screenings",
        "On-site Physiotherapy Sessions",
        "Comprehensive Ergonomic Reviews",
        "Stress Management Programs",
        "Dedicated Account Manager",
        "Quarterly Health Reports",
      ],
      price: "Custom Pricing",
      popular: true,
    },
    {
      id: 3,
      size: "Large Corporation",
      employees: "200+ employees",
      features: [
        "Weekly On-site Services",
        "Full Wellness Center Setup",
        "Advanced Health Analytics",
        "Executive Health Programs",
        "24/7 Support Hotline",
        "Custom Program Development",
        "ROI Tracking & Reporting",
      ],
      price: "Custom Pricing",
      popular: false,
    },
  ],
};

// Form submission handlers (mock)
export const formHandlers = {
  submitConsultation: (formData) => {
    console.log("Consultation form submitted:", formData);
    // Mock success response
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Consultation request submitted successfully!",
        });
      }, 1000);
    });
  },

  submitContact: (formData) => {
    console.log("Contact form submitted:", formData);
    // Mock success response
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message:
            "Message sent successfully! We will contact you within 24 hours.",
        });
      }, 1500);
    });
  },

  subscribeNewsletter: (email) => {
    console.log("Newsletter subscription:", email);
    // Mock success response
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: "Successfully subscribed to our newsletter!",
        });
      }, 800);
    });
  },
};
